(() => {
  'use strict';
  const name = 'adelais-quick-add-discount';
  if (customElements.get(name)) return;
  customElements.define(name, class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('[data-quick-add-modal]');
      if (!this.scope) return;
      this.onVariant = event => {
        const variant = event.detail?.variant;
        if (!variant?.id || !this.isConnected) return;
        this.setAttribute('data-la-dn-product-variant', String(variant.id));
      };
      this.scope.addEventListener('theme:variant:change', this.onVariant);
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('theme:variant:change', this.onVariant);
    }
  });
})();
